import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo } from 'react';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { ArrowDown2 } from '@ringcentral/juno-icon';
import { combineClasses, styled, useThemeProps, } from '../../../foundation';
import { RcIconButton } from '../../Buttons/IconButton';
import { AccordionSummaryStyle } from './styles';
import { RcAccordionSummaryClasses } from './utils';
var defaultIconButtonProps = { disableRipple: true };
var _RcAccordionSummary = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcAccordionSummary' });
    var classesProp = props.classes, expandIconProp = props.expandIcon, IconButtonProps = props.IconButtonProps, children = props.children, rest = __rest(props, ["classes", "expandIcon", "IconButtonProps", "children"]);
    var classes = useMemo(function () { return combineClasses(RcAccordionSummaryClasses, classesProp); }, [classesProp]);
    var expandIcon = useMemo(function () {
        return expandIconProp ? (React.createElement(RcIconButton, __assign({ symbol: expandIconProp === true ? ArrowDown2 : expandIconProp, tabIndex: -1 }, IconButtonProps))) : undefined;
    }, [IconButtonProps, expandIconProp]);
    return (React.createElement(MuiAccordionSummary, __assign({}, rest, { ref: ref, classes: classes, 
        // * hide that IconButtonProps, for user use Jsx paa from outside directly
        IconButtonProps: defaultIconButtonProps, expandIcon: expandIcon }), children));
});
var RcAccordionSummary = styled(_RcAccordionSummary)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), AccordionSummaryStyle);
RcAccordionSummary.defaultProps = {
    disableRipple: false,
};
RcAccordionSummary.displayName = 'RcAccordionSummary';
export { RcAccordionSummary };
var templateObject_1;
